<template>
    <div id="menu-header">
        <div class="container-fluid header" style="padding: 0">
            <div class="container">
                <router-link to="/">
                    <img src="../assets/img/logo-white.svg" id="logo" class="img-fluid">
                </router-link>
                <div class="social">
                    <router-link class="d-md-block d-sm-none" to="/seja-um-parceiro/acesso">
                        Acesso Parceiro
                        <icon name="user-circle-o" style="margin-bottom: -8px;" scale="2"></icon>
                    </router-link>
                </div>
            </div>
            <div class="container-fluid" style="background-color: rgba(0, 0, 0, 0.3); padding: 0;">
                <menu-header></menu-header>
            </div>
        </div>
    </div>
</template>

<script>
    import MenuHeader from "./Menu.vue";

    export default {
        components: {MenuHeader},
        name: 'page-header',
    }
</script>


// WEBPACK FOOTER //
// Header.vue?4707b3c9